import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { updateForm, updateTextForm } from 'store/Admin/Analyser';
import { updateTextOfTextList } from 'store/Admin/OrderDisplay';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';

import KeyWordListFormatter from 'components/Admin/KeyWordListFormatter';
import { removeStrongTags } from 'utils/StringUtils';

export const useAdminTextActions = ({
  textForm,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
  t,
  keywords,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  keyword,
  metaDescriptionTag,
  combinedKeywords,
  textTitle,
  titleTag,
  actualTextWordCount,
  initialTextWordCount,
  url,
  stuffedKeywords,
  websites,
  checkAllValidatedAndGenerateBill,
}) => {
  const dispatch = useDispatch();

  const verifyText = async () => {
    try {
      const res = await axiosPrivate.put(`/texts/${textForm.id}/verify`);

      dispatch(updateForm(res.data));

      dispatch(updateTextForm({ key: 'verifiedByAdmin', value: true }));

      dispatch(
        updateTextOfTextList({
          id: textForm.id,
          key: 'verifiedByAdmin',
          value: true,
        })
      );

      setErrorSuccessMsg(
        `${t('Le texte')} "${textForm.textTitle}" ${t(
          'a été vérifié avec succès'
        )}!`
      );
      setErrorSuccessImg(animationUrl + '/05_Contenu_livré.gif');
      setIsSuccess(true);
      setErrorSuccess(true);
    } catch (e) {
      console.log('🐛 useAdminTextActions verifyText error');
      throw e;
    }
  };

  const deliverText = async () => {
    const list = KeyWordListFormatter(keywords);
    const cleanedHtmlContent = removeStrongTags(actualHtmlContent);

    try {
      const res = await axiosPrivate.put(
        `/texts/${textForm.id}/admin-deliver`,
        {
          actualHtmlContent: cleanedHtmlContent,
          actualTextContent,
          analyseResult: analyseResult && JSON.stringify(analyseResult),
          keyword,
          metaDescriptionTag,
          semanticGap: list ? transformToSemanticGap(combinedKeywords) : null,
          textTitle,
          titleTag,
          totalNumberOfTextAdded: actualTextContent
            ? actualTextWordCount - initialTextWordCount
            : actualTextWordCount,
          url,
          stuffedKeywords: stuffedKeywords,
          internalLinking: websites,
        }
      );

      dispatch(updateForm(res.data));

      dispatch(updateTextForm({ key: 'delivered', value: true }));

      dispatch(
        updateTextOfTextList({
          id: textForm.id,
          key: 'delivered',
          value: true,
        })
      );
      dispatch(
        updateTextOfTextList({
          id: textForm.id,
          key: 'keyword',
          value: keyword,
        })
      );

      setErrorSuccessMsg(
        `${t('Le texte')} "${textForm.textTitle}" ${t(
          'a été livré avec succès'
        )}!`
      );
      setErrorSuccessImg(animationUrl + '/05_Contenu_livré.gif');
      //checkAllValidatedAndGenerateBill();
      setIsSuccess(true);
      setErrorSuccess(true);
    } catch (e) {
      switch (e.response.status) {
        case 400:
          setErrorSuccessMsg(
            t(
              'Veuillez changer les informations suivantes: titre et/ou mot clé'
            )
          );
          break;
        default:
          setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
          break;
      }
      setIsSuccess(false);
      setErrorSuccess(true);
    }
  };

  const verifyAndDeliverText = async () => {
    await verifyText();
    await deliverText();
  };

  return {
    verifyText,
    deliverText,
    verifyAndDeliverText,
  };
};
